import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Resubmissions = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Resubmissions";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
